import React from 'react';
import { Card, Form, Button, Spinner } from 'react-bootstrap';
import { FaSave } from 'react-icons/fa';

export default function WebhookForm({ formData, onChange, onSubmit, isSaving, cosCustomerId }) {
  return (
    <Card>
      <Card.Header className="bg-light">
        <h5 className="mb-0">Add New Integration</h5>
      </Card.Header>
      <Card.Body>
        <Form onSubmit={onSubmit}>
          <Form.Group className="mb-3">
            <Form.Label>Client ID</Form.Label>
            <Form.Control
              type="text"
              name="client_id"
              value={formData.client_id}
              onChange={onChange}
              required
              placeholder="Enter Guesty Client ID"
              autoComplete="off"
              autoCorrect="off"
              spellCheck="false"
              data-form-type="other"
            />
            <Form.Text className="text-muted">
              Your Guesty API Client ID
            </Form.Text>
          </Form.Group>
          
          <Form.Group className="mb-3">
            <Form.Label>Client Secret</Form.Label>
            <Form.Control
              type="password"
              name="client_secret"
              value={formData.client_secret}
              onChange={onChange}
              required
              placeholder="Enter Guesty Client Secret"
              autoComplete="one-time-code"
              autoCorrect="off"
              spellCheck="false"
              data-form-type="other"
            />
            <Form.Text className="text-muted">
              Your Guesty API Client Secret
            </Form.Text>
          </Form.Group>
          
          <Form.Group className="mb-3">
            <Form.Label>Customer ID</Form.Label>
            <Form.Control
              type="text"
              value={cosCustomerId}
              disabled
            />
            <Form.Text className="text-muted">
              Customer ID cannot be changed
            </Form.Text>
          </Form.Group>
          
          <Button 
            variant="primary" 
            type="submit"
            disabled={isSaving}
          >
            {isSaving ? (
              <>
                <Spinner animation="border" size="sm" className="me-2" />
                Saving...
              </>
            ) : (
              <>
                <FaSave className="me-2" /> Create Integration
              </>
            )}
          </Button>
        </Form>
      </Card.Body>
    </Card>
  );
}
